<template>
    <v-container grid-list-xl class="pt-2" style="min-width: 100%;">
        <v-layout row class="pt-0 pb-1 px-0">
            <div class="headline mt-1 ml-2 mr-3 pl-1">Dinner News</div>
            <v-btn
                small
                color="success"
                class="mr-2 mt-2"
                v-if="!newBroadcast"
                @click="addBroadcast()"
                >Add Message</v-btn
            >
        </v-layout>
        <v-card class="pa-3 mb-3">
            <div v-if="newBroadcast">
                <v-layout row class="mt-1">
                    <v-btn
                        small
                        style="height: 28px"
                        outline
                        class="ml-3 mt-3"
                        :loading="newBroadcast.uploading"
                        @click="pickFile()"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <div v-if="newBroadcast.files.length" class="mt-3 ml-2">
                        {{ newBroadcast.files[0].name }}
                    </div>
                    <input
                        type="file"
                        style="display: none"
                        ref="files"
                        accept="audio/*"
                        @change="onFilePicked($event)"
                    />
                    <v-menu
                        v-model="newBroadcast.datePickerMenu"
                        :close-on-content-click="true"
                        offset-y
                        full-width
                        prepend-icon="mdi-currency-usd"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                class="mx-3"
                                style="max-width: 200px"
                                v-model="newBroadcast.expires"
                                :value="newBroadcast.expires"
                                label="Expire Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="newBroadcast.expires"
                        ></v-date-picker>
                    </v-menu>
                    <div class="mt-3 ml-4">
                        <v-btn
                            class="my-0 pt-2 mr-2"
                            style="height: 28px"
                            @click.stop="cancelNewBroadcast()"
                            small
                            dark
                            color="default"
                            >Cancel
                        </v-btn>
                        <v-btn
                            class="my-0 pt-2 mr-2"
                            style="height: 28px"
                            @click.stop="saveBroadcast(newBroadcast)"
                            small
                            color="success"
                            >Save
                        </v-btn>
                    </div>
                </v-layout>
                <v-divider class="py-2 mb-1"></v-divider>
            </div>
            <div style="">
                <div v-for="(broadcast, index) in broadcasts">
                    <v-layout
                        row
                        row
                        justify-space-between
                        v-bind:class="{ expired: isExpired(broadcast) }"
                    >
                        <div
                            v-if="broadcast.date"
                            class="font-weight-medium ml-2 mt-3"
                        >
                            Uploaded On:<span class="ml-2 font-weight-light">{{
                                broadcast.date | time
                            }}</span>
                        </div>

                        <audio
                            class="mb-2 mt-1"
                            controls
                            :src="broadcast.recording"
                        ></audio>

                        <div
                            class="font-weight-medium mt-3 mr-2"
                            v-if="!broadcast.editing && broadcast.expires"
                        >
                            Expires:<span class="font-weight-light ml-2">{{
                                broadcast.expires | date
                            }}</span>
                            <span
                                v-if="isExpired(broadcast)"
                                style="background-color: red; color: #fff"
                                class="ml-2 px-2"
                                >Expired</span
                            >
                        </div>
                        <div
                            class="font-weight-medium mt-3 mr-2"
                            v-if="!broadcast.editing && !broadcast.expires"
                        >
                            Expires: NOT SET
                        </div>

                        <v-menu
                            v-if="broadcast.editing"
                            v-model="broadcast.datePickerMenu"
                            :close-on-content-click="true"
                            offset-y
                            full-width
                            prepend-icon="mdi-currency-usd"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    style="max-width: 200px"
                                    v-model="broadcast.expires"
                                    :value="broadcast.expires"
                                    label="Expire Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="broadcast.expires"
                            ></v-date-picker>
                        </v-menu>
                        <div v-if="broadcast.editing" class="mt-3">
                            <v-btn
                                class="my-0 pt-2 mr-2"
                                style="height: 28px"
                                @click.stop="cancelEditBroadcast(broadcast)"
                                small
                                dark
                                color="default"
                                >Cancel
                            </v-btn>
                            <v-btn
                                class="my-0 pt-2 mr-2"
                                style="height: 28px"
                                @click.stop="saveBroadcast(broadcast)"
                                small
                                color="success"
                                >Save
                            </v-btn>
                        </div>
                        <div>
                            <v-btn
                                class="my-0 pt-2"
                                v-if="!broadcast.editing"
                                @click.stop="editBroadcast(broadcast)"
                                flat
                                icon
                                color="success"
                            >
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                                class="my-0 pt-2"
                                v-if="!broadcast.editing"
                                @click.stop="openDeleteDialog(broadcast)"
                                flat
                                icon
                                color="success"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-layout>
                    <v-divider
                        class="py-2 mb-1"
                        v-if="index + 1 < broadcasts.length"
                    ></v-divider>
                </div>
            </div>
        </v-card>
        <v-dialog v-model="deleteBroadcastDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="text-warning headline pb-2"
                    >Are You Sure?</v-card-title
                >
                <div class="mx-3 mb-3">This will delete the message</div>
                <v-card-actions class="mx-0 px-2 pb-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteBroadcastDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteBroadcast"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import moment from "moment";
import { formatPhoneNumber, toISOLocal } from "../../utils/helpers.js";

export default {
    data() {
        return {
            broadcasts: [],
            processing: false,
            deleteBroadcastDialog: false,
            broadcastToDelete: "",
            today: new Date().toISOString().substr(0, 10),

            rules: {
                required: (value) => !!value || "Required.",

                phoneNumber: (v) => {
                    return (
                        !v ||
                        ([10, 11].includes(v.replace(/-/g, "").length) &&
                            /^\d+$/.test(v.replace(/-/g, ""))) ||
                        "Invalid Phone Number"
                    );
                },
            },

            newBroadcast: null,
        };
    },
    async created() {
        await this.loadBroadcasts();
    },
    computed: {},
    methods: {
        async loadBroadcasts() {
            let broadcasts = await this.$http.get(
                "https://dinner-compaign.azurewebsites.net/api/adminPortal/getDinnerNewsList?"
            );

            broadcasts = broadcasts.map((broadcast) => {
                broadcast.editing = false;
                broadcast.datePickerMenu = false;
                broadcast.expires = broadcast.expires
                    ? toISOLocal(new Date(broadcast.expires)).substr(0, 10)
                    : "";

                return broadcast;
            });

            const active = broadcasts.filter((b) => !this.isExpired(b));
            const inactive = broadcasts.filter((b) => this.isExpired(b));

            this.broadcasts = active;

            inactive.forEach((b) => this.broadcasts.push(b));
        },
        editBroadcast(broadcast) {
            broadcast.editing = true;
        },
        cancelEditBroadcast(broadcast) {
            broadcast.editing = false;

            this.loadBroadcasts();
        },
        isExpired(broadcast) {
            return (
                broadcast.expires && new Date(broadcast.expires) < new Date()
            );
        },
        pickFile() {
            this.$refs.files.click();
        },
        async onFilePicked(e, student) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            this.newBroadcast.files = files;

            try {
                var formData = new FormData();

                formData.append("audio", this.newBroadcast.files[0]);

                const response = await this.$http.post(
                    "api/adminPortal/uploadFile?",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                this.newBroadcast.recording = response.url;
            } catch (e) {
                this.newBroadcast.uploading = false;
            }
        },
        cancelNewBroadcast() {
            this.newBroadcast = null;
        },
        async saveBroadcast(broadcast) {
            if (!broadcast.recording.length) {
                this.$notify({
                    group: "notification",
                    text: "Please upload file",
                    type: "error",
                });

                return;
            }

            this.processing = true;

            try {
                await this.$http.post(
                    "https://dinner-compaign.azurewebsites.net/api/adminPortal/UpdateDinnerNews",
                    broadcast
                );

                this.processing = false;
                this.newBroadcast = null;

                this.loadBroadcasts();
            } catch (e) {
                this.processing = false;
            }
        },
        addBroadcast() {
            this.newBroadcast = {
                datePickerMenu: false,
                recording: "",
                files: [],
                uploading: false,
                expires: "",
            };
        },
        openDeleteDialog(broadcast) {
            this.broadcastToDelete = broadcast;
            this.deleteBroadcastDialog = true;
        },
        async deleteBroadcast() {
            try {
                this.processing = true;

                await this.$http.post(
                    "https://dinner-compaign.azurewebsites.net/api/adminPortal/deleteNews?id=" +
                        this.broadcastToDelete.id
                );

                this.processing = false;
                this.deleteBroadcastDialog = false;

                this.loadBroadcasts();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.reminder .v-input__slot {
    margin-bottom: 0px !important;
}
.expired {
    color: #999;
}
</style>
